import React, { ReactNode } from 'react';
import classNames from 'classnames';

import './AnalyticsCard.styles.scss';
import './AnalyticsCard.styles.responsive.scss';

type AnalyticsCardProps = {
  className?: string;
  title?: string;
  action?: ReactNode;
};

const AnalyticsCard: React.FC<AnalyticsCardProps> = (props) => {
  const { children, className, title, action } = props;

  const classes = classNames('analytics-card', className);

  return (
    <div className={classes}>
      {(title || action) && (
        <div className="analytics-card__heading">
          {title && <p>{title}</p>}
          {action}
        </div>
      )}

      {children}
    </div>
  );
};

export default AnalyticsCard;
